import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { authManager } from 'redux/action/auths';
import UserDetailTable from './userDetailTable/UserDetailTable';

const ConfigUser = () => {
  const dispatch = useDispatch();
  const auths = useSelector(store => store.auths.auth);

  if (!auths) {
    dispatch(authManager());
    return null;
  }

  return (
    <section>
      <UserDetailTable auths={auths} />
    </section>
  )
}

export default ConfigUser;